import Cookies from 'js-cookie'

const User = 'user'
const Code = 'code'
const Params = 'Params'
let clippingTime = 14 // 时间限制在两个星期内小时内
const OpenId = 'openId'
const UID = 'uid'
const SigParams = 'sigParams'
const Token = 'token'
const IsSystem = 'isSystem'
const CityName = 'cityName'
const District = 'district'

export function setCityName (cityName) {
  return Cookies.set(CityName, cityName, { expires: clippingTime })
}

export function getCityName () {
  return Cookies.get(CityName)
}

export function removeCityName () {
  return Cookies.remove(CityName)
}

export function setDistrict (district) {
  return Cookies.set(District, district, { expires: clippingTime })
}

export function getDistrict () {
  return Cookies.get(District)
}

export function removeDistrict () {
  return Cookies.remove(District)
}

export function getUser () {
  return Cookies.get(User)
}

export function setUser (id) {
  return Cookies.set(User, id, { expires: clippingTime })
}

export function getIsSystem () {
  return Cookies.get(IsSystem)
}

export function setIsSystem (id) {
  return Cookies.set(IsSystem, id, { expires: clippingTime })
}

export function removeUser () {
  return Cookies.remove(User)
}

export function getCode () {
  return Cookies.get(Code)
}

export function setCode (id) {
  return Cookies.set(Code, id, { expires: clippingTime })
}

export function removeCode () {
  return Cookies.remove(Code)
}

export function getParams () {
  return Cookies.get(Params)
}

export function setParams (data) {
  return Cookies.set(Params, data, { expires: clippingTime })
}

export function removeParams () {
  return Cookies.remove(Params)
}

export function getOpenId () {
  return Cookies.get(OpenId)
}

export function setOpenId (data) {
  return Cookies.set(OpenId, data, { expires: clippingTime })
}

export function removeOpenId () {
  return Cookies.remove(OpenId)
}

export function getUid () {
  return Cookies.get(UID)
}

export function setUid (data) {
  return Cookies.set(UID, data, { expires: clippingTime })
}

export function removeUid () {
  return Cookies.remove(UID)
}

export function getSigParams () {
  return Cookies.get(SigParams)
}

export function setSigParams (data) {
  return Cookies.set(SigParams, data, { expires: clippingTime })
}

export function removeSigParams () {
  return Cookies.remove(SigParams)
}

export function getToken () {
  return Cookies.get(Token)
}

export function setToken (data) {
  return Cookies.set(Token, data, { expires: clippingTime })
}

export function removeToken () {
  console.log("删除token")
  return Cookies.remove(Token)
}
